module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-regular-400.ttf?cf246e21218cab398b3d274f582ef394";